import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { UserService } from '@app/user.service';
import { ActivatedRoute, Router, RouterPreloader } from '@angular/router';
import { environment } from '@env/environment';

declare var $: any;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {
  TokenID: any;
  Token: any;

  constructor(
    private Api: ApiService, 
    private Util: UtilService, 
    private UserService: UserService,
    private Route: ActivatedRoute, 
    private Router: Router
  ) {
    this.Route.queryParams.subscribe((Params: any) => {
      this.TokenID = Params["id"];
    });
   }

  async ngOnInit() {
    this.Util.ShowWaiting(true);
    if (this.TokenID == null || this.TokenID == "") {

    }
    else {
      this.Token = await this.GetToken();
      if (this.Token == null) {
        this.Util.ErrorDialog("Invalid token.");
        $("#Save").attr("disabled", "disabled");
      }
      else {
        //await this.DeleteToken(this.TokenID);
      }
    }
    this.Util.ShowWaiting(false);
  }

  async GetToken() {
    let Res: any = await this.Api.getPortal("User", "GetToken", "token_id=" + this.TokenID);
    if (Res != null) {
      return Res.token_id
    }
    return Res;
  }

  async DeleteToken(TokenID: any) {
    let ParamObj: any = {
      token_id: TokenID
    };
    await this.Api.postPortal("user", "deletetoken", ParamObj);
  }

  async Save() {
    
    let NewPwd = $('#NewPassword').val();
    let ConfirmPwd = $('#ConfirmPassword').val();
    if (NewPwd == "") {
      $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่');
      return;
    }
    if (!this.UserService.IsValidatePassword(NewPwd))
    {
      $('#lblPwdError').html('**รหัสผ่านใหม่ไม่ตรงตามข้อกำหนด');
      return;
    }
    if (NewPwd != ConfirmPwd) {
      $('#lblPwdError').html('**กรุณายืนยันรหัสผ่านให้ตรงกัน');
      return;
    }
    this.Util.ShowWaiting(true);
    let ParamObj: any = {
      //username: this.Token.username, 
      newpassword: NewPwd, 
      token_id: this.TokenID
    };
    try {
      let Res: any = await this.Api.postPortal("user", "resetpassword", ParamObj);
      if (Res.code == "200") {
        this.Util.ShowWaiting(false);
        this.Util.SuccessDialog("เปลี่ยนรหัสผ่านสำเร็จ");
        let ThisTs = this;
        $("#btnSuccessOK").off('click');
        $("#btnSuccessOK").click(async function () {
          let Url: any = window.location.origin + "/mainmenu/login";
          window.location.href = Url;
        });
      }
      else {
        this.Util.WarningDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
      }
    }
    catch (err) {
      console.log(err);
      this.Util.WarningDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
    }
    this.Util.ShowWaiting(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/account/reset-password/reset-password.component.ts